const config = {
  // 站点名
  SiteName: "186526 Status",

  // 站点链接
  SiteUrl: "/",

  // UptimeRobot Api Keys
  // 支持 Monitor-Specific 和 Read-Only 两只 Api Key
  ApiKeys: ["ur1135938-8b85deefdbc0586dffa7bbbd"],

  // 是否显示监测站点的链接
  ShowLink: true,

  // 日志天数
  // 虽然免费版说仅保存60天日志，但测试好像API可以获取90天的
  // 不过时间不要设置太长，容易卡，接口请求也容易失败
  CountDays: 60,

  // 导航栏菜单
  Navi: [
    {
      text: "Home",
      url: "https://186526.xyz/",
    },
    {
      text: "GitHub Repo",
      url: "https://github.com/yb/uptime-status",
    },
    {
      text: "RSS",
      url: "https://get.status.186526.eu.org/@rss"
    }
  ],
};
export default config;
